import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 5;
  width: 100vw;
  background: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0vh;
  opacity: 0;
  transition: height 0s, opacity 0.2s ease-in-out;

  &.active {
    display: flex;
    height: 100vh;
    opacity: 1;
  }
`;

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 200px;
  border-radius: 8px;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 135px;
  height: 95px;
`;

export const Text = styled.div`
  display: flex;
  color: #fff;
  font-size: 1.7em;
`;

export const Spinner = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
`;
